module.exports = __webpack_public_path__ + "img/cursor_mid.75984208.png";